import React from "react";
import { Container, Wrapper } from "./styled";
import { Text } from "../../../../styled";
import DeleteButton from "./components/DeleteButton";

const ArticleCell = ({ row, value, show }) => {
  return (
    <Wrapper subRow={row.canExpand}>
      <Container>
        <DeleteButton id={row.original.id} show={show} />
        <Text {...row.getToggleRowExpandedProps()}>{value}</Text>
      </Container>
    </Wrapper>
  );
};

export default ArticleCell;
